import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    PUT_FILTEROPTION_SUCCESS,
    PUT_FILTEROPTION_FAILURE,
    RESET_CALENDAR_FILTERS_SUCCESS,
    RESET_CALENDAR_FILTERS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';
import { getUpdateFiltersApiEndpoint } from './endPoints';

export function* putFilterOptions(action) {
    const url = getUpdateFiltersApiEndpoint(
        convertObjectToQueryParams({ ...action.payload }), action.payload.assignedFlag
    );
    try {
        const result = yield axios.put(url).then((response) => response.data);

        yield put({ type: PUT_FILTEROPTION_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: PUT_FILTEROPTION_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* resetCalendarFilters(action) {
    const url = getUpdateFiltersApiEndpoint(
        convertObjectToQueryParams({ ...action.payload }), true
    );
    try {
        const result = yield axios.put(url).then((response) => response.data);

        yield put({ type: RESET_CALENDAR_FILTERS_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: RESET_CALENDAR_FILTERS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
